/**
 * Generated from ch6_p18.fla
 */
export function ch6_p18(this: Ich6_p18) {
	const bg = this.bg;
	ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const helmet = this.helmet;
	ch6_p18_hh_ch6_72dpi_p018psdAssethelmet.call(this.helmet);
	helmet.x = 530.75;
	helmet.y = 658.25;
	helmet.width = 88.50;
	helmet.height = 68.50;
	helmet.alpha = 1.00;
	if (helmet.onLayout) helmet.onLayout();
	const horse = this.horse;
	ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_horse.call(this.horse);
	horse.x = 640;
	horse.y = 713;
	horse.width = 337.00;
	horse.height = 535.50;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const holly = this.holly;
	ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_holly.call(this.holly);
	holly.x = 731.5;
	holly.y = 715.5;
	holly.width = 105.00;
	holly.height = 456.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 351.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframerlineas.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 571;
	linesRight.width = 95.00;
	linesRight.height = 152.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 345.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframellines.call(this.linesLeft);
	linesLeft.x = 3;
	linesLeft.y = 479.5;
	linesLeft.width = 76.50;
	linesLeft.height = 337.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_bg(this: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p18_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p18_hh_ch6_72dpi_p018psdAssethelmet(this: Ich6_p18_hh_ch6_72dpi_p018psdAssethelmet) {
	if (this.setLayoutTexture) this.setLayoutTexture("helmet", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_horse(this: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p18_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_holly(this: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p18_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeRframe(this: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframerlineas(this: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframerlineas) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlineas", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeLframe(this: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframellines(this: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p18Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p18Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p18Sprite extends Ich6_p18Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p18Text extends Ich6_p18Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p18Polygon extends Array<number> {
}
interface Ich6_p18 {
	readonly bg: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_bg;
	readonly helmet: Ich6_p18_hh_ch6_72dpi_p018psdAssethelmet;
	readonly horse: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_horse;
	readonly holly: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_holly;
	readonly frameRight: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeRframe;
	readonly linesRight: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframerlineas;
	readonly frameLeft: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeLframe;
	readonly linesLeft: Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframellines;
}
interface Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_bg extends Ich6_p18Sprite {
}
interface Ich6_p18_hh_ch6_72dpi_p018psdAssethelmet extends Ich6_p18Sprite {
}
interface Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_horse extends Ich6_p18Sprite {
}
interface Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_holly extends Ich6_p18Sprite {
}
interface Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeRframe extends Ich6_p18Sprite {
}
interface Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframerlineas extends Ich6_p18Sprite {
}
interface Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframeLframe extends Ich6_p18Sprite {
}
interface Ich6_p18_hh_ch6_72dpi_p018psdAssetchp6_p18_wcframellines extends Ich6_p18Sprite {
}
